import { configureStore } from '@reduxjs/toolkit';
import reduxThunk from 'redux-thunk';

import authReducer from '../modules/auth/redux/reducer';

const rootReducer = {
  auth: authReducer
};

const middlewares = [ reduxThunk ];

if (process.env.NODE_ENV === `development`) {
  const { logger } = require(`redux-logger`);
  middlewares.push(logger);
}

const store = configureStore({ reducer: rootReducer, middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares) });
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;


